<template>
  <div>
    <h3 class="text-lg">{{ t('app.payments.invoice.details') }}</h3>
    <button
      class="group relative flex w-full items-center justify-between gap-2 overflow-hidden rounded-lg border p-2 text-left hover:text-primary-500 dark:border-yapdarkgray-600 dark:hover:text-primary-dark-300"
      :disabled="state.loading"
      @click="downloadInvoice"
    >
      <div
        v-if="state.loading"
        class="absolute left-0 flex h-full w-full items-center justify-center bg-yapgray-100/60 dark:bg-yapdarkgray-900/80"
      >
        <YapLoader :size="YapLoaderSizes.Small" class="mr-4" />
      </div>
      <YapIcon name="ebill-round" class="h-8 w-8" />
      <div class="flex-grow">
        <YapAmount
          :amount="invoice.amount"
          :currency="invoice.currency"
          :show-positive-sign="invoice.type === InvoiceType.Credit"
        />
        <div class="text-sm text-yapgray-500 group-hover:text-primary-200 dark:group-hover:text-primary-dark-600">
          {{ formatIsoToLocaleString(invoice.invoiceDate) }}
        </div>
      </div>
      <YapIcon name="document-text-outline" class="h-8 w-8" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue';

import apiGw from '@/services/apiGw';
import { useI18n } from '@/plugins/i18n';
import { downloadFile } from '@/utils/file';
import YapIcon from '@/components/YapIcon.vue';
import YapAmount from '@/components/YapAmount.vue';
import { formatIsoToLocaleString } from '@/utils/locale';
import YapLoader, { YapLoaderSizes } from '@/components/YapLoader.vue';
import { Invoice, InvoiceType } from '@/components/payments/types/invoice';

const props = defineProps<{
  invoice: Invoice;
}>();

const { t } = useI18n();

interface State {
  loading: boolean;
}
const state: State = reactive({
  loading: false
});

async function downloadInvoice() {
  state.loading = true;
  try {
    const rsp = await apiGw.get(props.invoice._links.pdf.uri, { responseType: 'arraybuffer' });
    const content = rsp.data;
    const contentType = rsp.headers['content-type'];
    const filename = rsp.headers['content-disposition'].split('=')[1];
    downloadFile(content, filename, contentType);
    state.loading = false;
  } catch (error) {
    console.error('Something went wrong...', error);
    state.loading = false;
  }
}
</script>
